import { render, staticRenderFns } from "./PropertyPackCategory.vue?vue&type=template&id=3be5326a&scoped=true"
import script from "./PropertyPackCategory.vue?vue&type=script&lang=ts"
export * from "./PropertyPackCategory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be5326a",
  null
  
)

export default component.exports